import React from 'react';
import { connectHits } from 'react-instantsearch-core';
import { Box, Collapse, Text } from '@chakra-ui/react';
import type { Hit, HitsProvided } from 'react-instantsearch-core';

import CustomHit, { CustomHitResult } from './Hit';
import NoResults from './NoResults';

export type CustomHitType = Hit & CustomHitResult;

type HitsProps = HitsProvided<CustomHitType>;

const ResultHeader: React.FC = ({ children }) => (
  <Text as="p" textStyle="label">
    {children}
  </Text>
);

const Hits: React.FunctionComponent<HitsProps> = ({ hits }) => {
  return (
    <Box mt="16">
      <Collapse in={hits.length > 0} animateOpacity>
        {hits.length === 1 && <ResultHeader>Showing 1 result</ResultHeader>}
        {hits.length > 1 && (
          <ResultHeader>Showing {hits.length} results</ResultHeader>
        )}
        {hits.map((h) => (
          <Box key={h.slug} mt={6}>
            <CustomHit hit={h} />
          </Box>
        ))}
      </Collapse>
    </Box>
  );
};

export default connectHits<HitsProps, CustomHitType>(Hits);
